import { STRINGS } from 'config';
import _find from 'lodash/find';
import _map from 'lodash/map';
import request from 'superagent';
import { updateIntercom } from 'utils/intercom';
import { getFeatureFlags } from 'store/action/featureFlags';
import status from 'http-status';
import { getPracticeCookie, setPracticeCookie } from 'utils/cookies';

const {
  API: { ROOT_URL },
  REDUCERS: {
    APP: { SET_USER_DATA },
    AUTH: {
      API_CHECK_AUTHENTICATION_REQUEST,
      API_CHECK_AUTHENTICATION_SUCCESS,
      CHECK_AUTHENTICATION_ERROR,
    },
  },
} = STRINGS;

const color = 'colorExpressionExpression1';

const getOrgName = (id, orgDetails) => {
  if (orgDetails) {
    return orgDetails?.find(ea => ea.id === id)?.prettyName;
  }
  return id;
};

const getOrgPcmCode = (id, orgDetails) => orgDetails?.find(ea => ea.id === id)?.pcmCode;

export const redirectUserToLoginScreen = () => {
  window.location.href = `${ROOT_URL}/auth/remote?callbackUrl=${window.location.href}`;
};

export const redirectToLogout = () => {
  window.location.href = `${ROOT_URL}/auth/logout`;
};

export function apiGetAuthenticationCheck(dispatch) {
  dispatch({ type: API_CHECK_AUTHENTICATION_REQUEST });
  return request
    .get(`${ROOT_URL}/usermanagement/users/current`)
    .withCredentials()
    .then(resp => {
      dispatch({ type: API_CHECK_AUTHENTICATION_SUCCESS });
      const { orgIds, email, orgDetails, name, roles } = resp?.body;
      const { practiceIds, ehubIds, admin } = orgIds;
      if (!practiceIds && !ehubIds) {
        redirectToLogout();
        return false;
      }
      const practices = practiceIds ? practiceIds.map(ea => ({
        prettyName: getOrgName(ea, orgDetails),
        pcmCode: getOrgPcmCode(ea, orgDetails),
        id: ea,
        color,
        isEhub: false,
      })) : [];
      const ehubs = ehubIds ? ehubIds.map(ea => ({
        prettyName: getOrgName(ea, orgDetails),
        id: ea,
        color,
        isEhub: true,
      })) : [];
      const adminRights = admin || [];
      if (email) {
        updateIntercom({
          email,
          user_id: email,
          name: email,
          companies: _map([...practices, ...ehubs], ea => ({ id: ea.id, name: ea.id })),
        });
      }
      const persistedPracticeId = getPracticeCookie();
      const persistedPractice = _find(practices, { id: persistedPracticeId });
      const persistedEhub = _find(ehubs, { id: persistedPracticeId });
      const selectedPractice = persistedPractice || persistedEhub || practices[0] || ehubs[0];
      setPracticeCookie(selectedPractice.id);
      dispatch({
        type: SET_USER_DATA,
        payload: { practices, ehubs, adminRights, currentUserEmail: email, currentUserName: name, selectedPractice, roles },
      });
      getFeatureFlags(selectedPractice?.id)(dispatch);
      return true;
    })
    .catch(err => {
      dispatch({ type: CHECK_AUTHENTICATION_ERROR, payload: err });
      if (err.status === status.UNAUTHORIZED) {
        redirectUserToLoginScreen();
      } else {
        redirectToLogout();
      }
      return false;
    });
}
